import { useDisclosure } from '@hooks/useDisclosure';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { GridActionsCellItem } from '@mui/x-data-grid';
import { useImpactsOnStakeholdersForm } from '@Router/ImpactsOnStakeholdersManagement/Containers/ImpactsOnStakeholdersFormProvider';
import { useWatch } from 'react-hook-form';
import {
  StakeholderAnalysisFormValues,
  StakeholderGroupFormValues,
} from '../../../ImpactsOnStakeholdersFormProvider/types';
import ModalAddStakeholderAnalysis from '../../ModalAddStakeholderAnalysis';
import { sortStakeholderGroups } from '../../utils';

interface ActionEditStakeholderAnalysisProps {
  rowId: string;
}

const ActionEditStakeholderAnalysis = ({
  rowId,
}: ActionEditStakeholderAnalysisProps) => {
  const { getValues } = useImpactsOnStakeholdersForm();
  const [isModalOpen, { open: openModal, close: closeModal }] = useDisclosure();

  const stakeholderData =
    getValues(`stakeholderAnalysis.stakeholderGroups`) || [];

  const sortedGroups = sortStakeholderGroups(stakeholderData);

  const index = Number(rowId.replace(/^(DETAILS_|NEW_)/, ''));
  let stakeholderDataMatch: StakeholderGroupFormValues | undefined;

  if (rowId.startsWith('DETAILS_')) {
    stakeholderDataMatch = stakeholderData.find(
      (item: StakeholderGroupFormValues) => item.id === index
    );
  } else {
    stakeholderDataMatch = sortedGroups[index - 1];
  }

  const { completedSection } = useWatch({
    name: 'stakeholderAnalysis',
  }) as StakeholderAnalysisFormValues;

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};
  const isEditingDisabled = isCompletedTh && isCompletedEn;

  return (
    <>
      <GridActionsCellItem
        key="edit"
        icon={<EditOutlinedIcon fontSize="small" />}
        label="Edit"
        onClick={openModal}
        disabled={isEditingDisabled}
      />
      {isModalOpen && (
        <ModalAddStakeholderAnalysis
          open={isModalOpen}
          close={closeModal}
          mode="edit"
          editData={stakeholderDataMatch}
          editIndex={index}
          rowId={rowId}
        />
      )}
    </>
  );
};

export default ActionEditStakeholderAnalysis;
